import { UniversityExistenceEnum } from '@simppl/repository-admin/tutor/res';

export const isUniversityNew = (existence: UniversityExistenceEnum | null) => {
  if (!existence) return false;
  return existence === UniversityExistenceEnum.NONE;
};

export const isMajorNew = (existence: UniversityExistenceEnum | null) => {
  if (!existence) return false;
  return existence !== UniversityExistenceEnum.ALL;
};
